import React, { useEffect, useState, useContext } from "react";
import ReactRouterPropTypes from "react-router-prop-types";
import Error from "containers/Error";
import Receipt from "components/Receipt";
import Loading from "components/Loading";
import { StoreContext } from "components/StoreContext";
import { CartContext } from "components/CartContext";

const Order = ({ match }) => {
  const { store, StoreAPI } = useContext(StoreContext);
  const { customerAddress } = useContext(CartContext);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [order, setOrder] = useState(null);
  const { orderId: id } = match.params;

  useEffect(() => {
    if (store.loaded && customerAddress.displayName) {
      StoreAPI.get(`orders/${id}`)
        .then(response => {
          setLoading(false);
          setError(null);
          setOrder({
            omsOrderId: response.data.omsOrderId,
            userId: response.data.userId,
            orderNumber: response.data.orderNumber,
            orderDate: response.data.orderDate,
            billingAddress: response.data.billingAddress,
            addressId: response.data.billingAddress.addressId,
            displayName: customerAddress.displayName,
            email: response.data.billingAddress.emailAddress,
            address1: response.data.billingAddress.address1,
            address2: response.data.billingAddress.address2,
            cityName: response.data.billingAddress.cityName,
            stateName: response.data.billingAddress.stateName,
            postalCode: response.data.billingAddress.postalCode,
            countryName: response.data.billingAddress.countryName,
            promotionalDiscount: response.data.promotionalDiscount,
            orderLineItems: response.data.orderLineItems,
            unitPrice: response.data.unitPrice,
            discount: response.data.discount,
            subTotal: response.data.subTotal,
            taxCost: response.data.taxCost,
            total: response.data.total,
            cardType: response.data.cardType,
            creditCardNumber: response.data.creditCardNumber
          });
        })
        .catch(response => {
          setLoading(false);
          setError(response.status);
        });
    }
  }, [id, store.loaded, StoreAPI, customerAddress.displayName]);

  return (
    <div>
      <style
        dangerouslySetInnerHTML={{
          __html:
            ".site {padding: 0} .site__header, .site__footer { display: none; } .site__body { background: #fff; }"
        }}
      />
      {error && !loading && <Error errorCode={error} />}
      {!error && loading && <Loading bg="transparent" />}
      {!error && order && <Receipt order={order} />}
    </div>
  );
};

Order.propTypes = {
  match: ReactRouterPropTypes.match.isRequired
};

export default Order;
